import { DEFAULT_SPACE_SIZE, DEFAULT_GRID_RESOLUTION } from "../consts";
import { Position, Size } from "../types";

export function pixelToGridPositionSloppy(pixelPosition: Position) {
  return {
    x: pixelPosition.x / DEFAULT_GRID_RESOLUTION,
    y: pixelPosition.y / DEFAULT_GRID_RESOLUTION,
  };
}

export function pixelToGridSizeSloppy(pixelSize: Size) {
  return {
    width: pixelSize.width / DEFAULT_GRID_RESOLUTION,
    height: pixelSize.height / DEFAULT_GRID_RESOLUTION,
  };
}

// TODO change pos/size into aliases for vector2d?
export function pixelToGridPosition(pixelPosition: Position, round?: boolean) {
  const adjust = round ? Math.round : Math.floor;
  return {
    x: adjust(pixelPosition.x / DEFAULT_GRID_RESOLUTION),
    y: adjust(pixelPosition.y / DEFAULT_GRID_RESOLUTION),
  };
}

export function pixelToGridSize(pixelSize: Size, round?: boolean) {
  const adjust = round ? Math.round : Math.floor;
  return {
    width: adjust(pixelSize.width / DEFAULT_GRID_RESOLUTION),
    height: adjust(pixelSize.height / DEFAULT_GRID_RESOLUTION),
  };
}

export function gridToPixelPosition(gridPosition: Position) {
  return {
    x: gridPosition.x * DEFAULT_GRID_RESOLUTION,
    y: gridPosition.y * DEFAULT_GRID_RESOLUTION,
  };
}

export function gridToPixelSize(gridSize: Size) {
  return {
    width: gridSize.width * DEFAULT_GRID_RESOLUTION,
    height: gridSize.height * DEFAULT_GRID_RESOLUTION,
  };
}

export function subtractPosition(a: Position, b: Position) {
  return {
    x: a.x - b.x,
    y: a.y - b.y,
  };
}

export function equalPosition(a: Position| undefined, b: Position| undefined) {
  if (!a || !b) return false;
  return a.x === b.x && a.y === b.y;
}

export function addPosition(a: Position, b: Position) {
  return {
    x: a.x + b.x,
    y: a.y + b.y,
  };
}

export function multiplyPosition(a: Position, b: Position) {
  return {
    x: a.x * b.x,
    y: a.y * b.y,
  };
}

export function addSize(a: Size, b: Size) {
  return {
    width: a.width + b.width,
    height: a.height + b.height,
  };
}

export function clampPosition({ x, y }: Position) {
  return {
    x: Math.max(Math.min(x, DEFAULT_SPACE_SIZE.width), 0),
    y: Math.max(Math.min(y, DEFAULT_SPACE_SIZE.height), 0),
  };
}
